import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';


const Cancel = () => {
  const navigate = useNavigate();


  useEffect(() => {
    localStorage.removeItem('pendingOrder');
    toast.error('Payment was cancelled');
  }, []);


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-lg text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">Payment Cancelled</h2>
        <p className="text-gray-600 mb-6">Your order has been cancelled. No payment has been processed.</p>
        <div className="space-y-4">
          <button
            onClick={() => navigate('/checkout')}
            className="bg-purple-500 text-white px-6 py-2 rounded-full hover:bg-purple-600 transition-colors w-full"
          >
            Try Again
          </button>
          <button
            onClick={() => navigate('/')}
            className="border border-purple-500 text-purple-500 px-6 py-2 rounded-full hover:bg-purple-50 transition-colors w-full"
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cancel; 